"use client";

import { Button } from "@/intent-components/ui/button";
import { IconPencilBox } from "@intentui/icons";
import { useState } from "react";
import {
  AddOrCreateClient,
  ExistingConfiguration,
  ProfileSelection,
} from "./addOrCreateClient";

type EditClientProps = {
  allProfiles: ProfileSelection[];
  existingConfiguration: ExistingConfiguration;
};

export function EditClient({
  allProfiles,
  existingConfiguration,
}: EditClientProps) {
  const [isEditing, setIsEditing] = useState(false);

  return (
    <>
      <Button
        intent="outline"
        size="square-petite"
        onPress={() => setIsEditing(true)}
      >
        <IconPencilBox />
      </Button>

      <AddOrCreateClient
        isOpen={isEditing}
        onOpenChange={setIsEditing}
        allProfiles={allProfiles}
        existingConfiguration={existingConfiguration}
      />
    </>
  );
}
